/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { APIProvider, Map, InfoWindow, AdvancedMarker, Pin, useAdvancedMarkerRef, useMap } from '@vis.gl/react-google-maps';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import zackatPin from '../data/mappin.png';
import otherPin from '../data/spotlight-poi.png';
import './Map.css';

// Separate component inside APIProvider to access the map instance via hook
const MapBoundsFitter = ({ markers }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || markers.length === 0) return;

    // Create a new boundary box
    const bounds = new window.google.maps.LatLngBounds();

    // Extend the boundaries to include each marker's position
    markers.forEach((marker) => {
      console.log(marker);
      bounds.extend({ lat: marker.lat, lng: marker.lng });
    });

    // Adjust map zoom and center to fit the boundary box
    console.log('fit bounds', bounds);
    map.fitBounds(bounds);
    // Get the exact center coordinate point of the bounds
    const centerLatLng = bounds.getCenter();

    map.setCenter(centerLatLng);
  }, [map, markers]);

  return null; // This component handles side effects, no UI needed
};

const GMap = ({ props }) => {
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [refreshData, setRefreshData] = useState(true);
  const [searchParams] = useSearchParams();
  let associateid = searchParams.get('id');
  let centerlat = Number(searchParams.get('lat'));
  let centerlng = Number(searchParams.get('lng'));
  let name = String(searchParams.get('name'));
  const timerid = useRef();
  // const otherPin = 'https://mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-poi.png';

  const [position, setPosition] = useState({ lat: 0, lng: 0 });
  const [markers, setMarker] = useState([{ lat: centerlat, lng: centerlng, title: name, _id: 1, info: 'Last known location' }]);
  const [activeMarker, setActiveMarker] = useState(null);
  const { REACT_APP_API_ENDPOINT } = process.env;
  let { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env;
  const { REACT_APP_GOOGLE_MAPS_API_KEY_DEV } = process.env;
  const { REACT_APP_ENV } = process.env;

  const { REACT_APP_GOOGLE_MAPS_ID } = process.env;
  const usr = JSON.parse(localStorage.getItem('user'));
  const [infoWindowShown, setInfoWindowShown] = useState(false);
  const [markerRef, amarker] = useAdvancedMarkerRef();
  if (props && props._id.length > 0) {
    associateid = props._id;
    name = props.name;
    if (props.latlng && props.latlng.latitude && props.latlng.longitude) {
      centerlat = props.latlng.latitude;
      centerlng = props.latlng.longitude;
    }
  }
  if (!REACT_APP_ENV || REACT_APP_ENV === '') {
    REACT_APP_GOOGLE_MAPS_API_KEY = REACT_APP_GOOGLE_MAPS_API_KEY_DEV;
  }

  const handleActiveMarker = (marker) => {
    setInfoWindowShown((isShown) => !isShown);
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  let initialMarkers = [];
  const [reload, setReload] = useState(false);
  useEffect(() => {
    const getData = async () => {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/events?associateid=${associateid}&limit=7`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setData(response.data);
        initialMarkers = [];
        if (response.data) {
          const reversedArray = [...response.data].reverse();
          reversedArray.map((event, index) => {
            if (event && event.device && event.latlng && event.latlng.latitude && event.latlng.longitude && event.latlng.latitude !== 0 && event.latlng.longitude !== 0) {
              const marker = {
                lat: event.latlng.latitude,
                lng: event.latlng.longitude,
                title: event.device,
                _id: event._id,
                index: index - reversedArray.length,
                info: `Timestamp: ${format(parseISO(event.timestamp), 'MM/dd/yy hh:mm')}`,
              };
              initialMarkers.push(marker);
            }
          });
        }
        if (initialMarkers.length > 0) {
          setPosition({ lat: initialMarkers[0].lat, lng: initialMarkers[0].lng });
          setLoadingData(false);
          setMarker(initialMarkers);
        }
      })
        .catch(() => {
        });
    };
    getData();
  }, [centerlat, reload]);

  useEffect(() => {
    timerid.current = setTimeout(setReload(!reload), 30000);
    return () => {
      timerid.current = clearTimeout(timerid.current);
    };
  }, [refreshData]);
  if (loadingData && !refreshData) {
    return <p>Loading... </p>;
  }
  // clicking the marker will toggle the infowindow
  const handleMarkerClick = useCallback(
    () => setInfoWindowShown((isShown) => !isShown),
    [],
  );
  // if the maps api closes the infowindow, we have to synchronize our state
  const handleClose = useCallback(() => setInfoWindowShown(false), []);

  return (
    <APIProvider
      apiKey={`${REACT_APP_GOOGLE_MAPS_API_KEY}`}
    >
      {/* }
      <button
        className="button"
        type="button"
        onClick={() => setRefreshData(!refreshData)}
      >
        Refresh
      </button>
      */}
      <Map
        style={{ width: '100%', height: '100vh' }}
        defaultCenter={{ lat: centerlat, lng: centerlng }}
        mapId={`${REACT_APP_GOOGLE_MAPS_ID}`}
        defaultZoom={4}
        onClick={() => setActiveMarker(null)}
        gestureHandling="greedy"
        disableDefaultUI={false}

      >
        {/* <Marker position={{ lat: 33.049831, lng: -96.838485 }} /> */}
        {markers.map((marker, index) => (
          <AdvancedMarker
            className="bounce"
            key={marker._id}
            ref={markerRef}
            draggable
            position={marker}
            onClick={() => handleActiveMarker(marker)}
          >
            {index === markers.length - 1 ? (
              <img src={zackatPin} width="60px" height="60px" />
            )
              : <img src={otherPin} height="60px" />}
            {/*
            <Pin
              background="#000000"
              borderColor="#ffffff"
              glyphColor="#ff0000"
              title={marker.title}
            />
            */}
            {infoWindowShown && (
              <InfoWindow
                position={activeMarker}
                onClose={handleClose}
              >
                <h2>Name: {props.name || ''}</h2>
                <h2>Device: {activeMarker && activeMarker.title ? activeMarker.title : ''}</h2>
                <p>Info: {activeMarker && activeMarker.info ? activeMarker.info : ''}</p>
                {/* <p>ID:{activeMarker && activeMarker._id ? activeMarker._id : ''}</p> */}
                {/* <p>Index:{activeMarker.index}</p> */}
              </InfoWindow>
            )}
          </AdvancedMarker>
        ))}
        <MapBoundsFitter markers={markers} />

      </Map>
    </APIProvider>

  );
};
export default GMap;
